export default "* Ask & Liv-ark ”Mini-fødekæde” <a href=\"https://www.blivnaturligvis.dk/askogliv2\" target=\"_blank\">www.blivnaturligvis.dk/askogliv2</a>\n";